import BaseService from "./base.service";

const API_URL = process.env.VUE_APP_API_URL;

class Index extends BaseService {
  bookNow(payload) {
    return this.post(`${API_URL}/api/transaction/bet`, payload)
      .then((res) => res.data)
      .catch((err) => err);
  }

  getLocale(account, game, lang) {
    return this.get(`${API_URL}/api/locale?account=${account}&lang=${lang}&game=${game}`).then(({ data }) => data)
  }

  async getGamesByAccount(account) {
    return this.get(`${API_URL}/api/account-games?account=${account}`).then(({ data }) => data)
  }

  async getSettings(account, game) {
    return this.get(`${API_URL}/api/account-settings?account=${account}&game=${game}`).then(({ data }) => data)
  }

  async getListCountry(account, game) {
    return this.post(`${API_URL}/api/countries`, {
      account: account,
      game: game
    }).then(({ data }) => data)
  }

}

export default new Index();
